import './App.css';
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import Home from './Components/Home';
import Layout from './Components/Layout';
import About from './Components/About';
import Services from './Components/Services';
import Portfolio from './Components/Portfolio';
import Contact from './Components/Contact';
import Technologies from './Components/Technologies';

function App() {
  return (
    <Router>
      <Routes>
          <Route path="/" element={
            <Home />
          } />
          <Route path="/about" element={
            <About />
          } />
          <Route path="/services" element={
            <Services />
          } />
          <Route path="/portfolio" element={
            <Portfolio />
          } />
          <Route path="/technologies" element={
            <Technologies />
          } />
          <Route path="/contact" element={
            <Contact />
          } />
      </Routes>
    </Router>
  );
}

export default App;